/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import React, { useEffect } from 'react';

import useIsMobile from 'hooks/browser/useIsMobile';
import BlueHeaderOnWhiteLayout from 'layouts/BlueHeaderOnWhite';
import useIdentity from 'hooks/identity/useIdentity';
import HeaderText from 'components/HeaderText';

import { useDispatch } from 'react-redux';
import getIdentityEndpoint from 'api/session/getIdentity';

import AddCard from 'containers/PushToCard/AddCard';


const AddPayeePushToCard = ({
  active,
  updateState
}) => {
  const dispatch =  useDispatch();

  const identity = useIdentity();
  const isNextStep = identity
    ?.nextSetupSteps
    ?.some(x => x === 'AddPayeePushToCard');

  const isMobile = useIsMobile();

  useEffect(() => {
    updateState('loaded');
  }, []);

  useEffect(() => {
    if (!isNextStep) {
      updateState('skipped');
    }
  }, [isNextStep]);

  // Render
  if (!active) return <></>;

  return (
    <BlueHeaderOnWhiteLayout
      backgroundColor="#f7f7f7"
      contentWidth={isMobile ? null : 1000}
      hideLoginLink={true}
    >
      <div className="viewstrap" style={{ padding: '12px', paddingTop: isMobile ? null : '20px' }}>
        <HeaderText>
          Add Your Card Account
        </HeaderText>

        <AddCard addressBookId={identity.setupAddressBookId}
          onComplete={() => dispatch(getIdentityEndpoint())} />
      </div>
    </BlueHeaderOnWhiteLayout>
  );
};

export default AddPayeePushToCard;
